"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _FAIcon = require("../icon/FAIcon");

var _FAIcon2 = _interopRequireDefault(_FAIcon);

require("./Image.scss");

var _AbstractReactComponent = require("../AbstractReactComponent");

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta obrázku s možností jednu vybrat kliknutím na checkbox.
 */
var Image = function (_AbstractReactCompone) {
    (0, _inherits3.default)(Image, _AbstractReactCompone);

    function Image() {
        (0, _classCallCheck3.default)(this, Image);
        return (0, _possibleConstructorReturn3.default)(this, (Image.__proto__ || (0, _getPrototypeOf2.default)(Image)).apply(this, arguments));
    }

    (0, _createClass3.default)(Image, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                imgProps = _props.imgProps,
                className = _props.className,
                disabled = _props.disabled,
                checked = _props.checked,
                onCheck = _props.onCheck,
                renderItem = _props.renderItem,
                onClick = _props.onClick,
                src = _props.src;


            var clsCont = (0, _classnames2.default)("image-container", className, {
                disabled: disabled
            });

            return _react2.default.createElement(
                "div",
                { className: clsCont },
                _react2.default.createElement(
                    "div",
                    { className: "check p-2 fa-stack fa-sm" + (checked ? " active" : ""), onClick: disabled ? function () {} : onCheck },
                    checked && _react2.default.createElement(_FAIcon2.default, { fixedWidth: true, className: "fa-stack-2x", icon: "circle" }),
                    _react2.default.createElement(_FAIcon2.default, { fixedWidth: true, className: checked ? "fa-stack-1x" : "fa-stack-2x", icon: checked ? "check" : "circle-o" })
                ),
                renderItem ? renderItem(src, checked) : _react2.default.createElement("img", (0, _extends3.default)({}, imgProps, { onClick: onClick, src: src }))
            );
        }
    }]);
    return Image;
}(_AbstractReactComponent2.default); // --


Image.PropTypes = {
    src: _react2.default.PropTypes.string,
    checked: _react2.default.PropTypes.bool,
    onCheck: _react2.default.PropTypes.func, // klik na checkbox
    onClick: _react2.default.PropTypes.func, // klik na obrázek - např. pro možnost akce zobrazení náhledu apod.
    renderItem: _react2.default.PropTypes.func, // render obrázku, pokud je potřeba jiný než standardní
    disabled: _react2.default.PropTypes.bool, // je disabled
    imgProps: _react2.default.PropTypes.object // props pro img element
};
Image.defaultProps = {};
exports.default = Image;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvaW1hZ2UvSW1hZ2UuanN4Il0sIm5hbWVzIjpbIkltYWdlIiwicHJvcHMiLCJpbWdQcm9wcyIsImNsYXNzTmFtZSIsImRpc2FibGVkIiwiY2hlY2tlZCIsIm9uQ2hlY2siLCJyZW5kZXJJdGVtIiwib25DbGljayIsInNyYyIsImNsc0NvbnQiLCJBYnN0cmFjdFJlYWN0Q29tcG9uZW50IiwiUHJvcFR5cGVzIiwiUmVhY3QiLCJzdHJpbmciLCJib29sIiwiZnVuYyIsIm9iamVjdCIsImRlZmF1bHRQcm9wcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBOzs7SUFHTUEsSzs7Ozs7Ozs7OztpQ0FjTztBQUFBLHlCQUMrRSxLQUFLQyxLQURwRjtBQUFBLGdCQUNFQyxRQURGLFVBQ0VBLFFBREY7QUFBQSxnQkFDWUMsU0FEWixVQUNZQSxTQURaO0FBQUEsZ0JBQ3VCQyxRQUR2QixVQUN1QkEsUUFEdkI7QUFBQSxnQkFDaUNDLE9BRGpDLFVBQ2lDQSxPQURqQztBQUFBLGdCQUMwQ0MsT0FEMUMsVUFDMENBLE9BRDFDO0FBQUEsZ0JBQ21EQyxVQURuRCxVQUNtREEsVUFEbkQ7QUFBQSxnQkFDK0RDLE9BRC9ELFVBQytEQSxPQUQvRDtBQUFBLGdCQUN3RUMsR0FEeEUsVUFDd0VBLEdBRHhFOzs7QUFHTCxnQkFBTUMsVUFBVSwwQkFDWixpQkFEWSxFQUVaUCxTQUZZLEVBRUQ7QUFDUEM7QUFETyxhQUZDLENBQWhCOztBQVFBLG1CQUFPO0FBQUE7QUFBQSxrQkFBSyxXQUFXTSxPQUFoQjtBQUNIO0FBQUE7QUFBQSxzQkFBSyxXQUFXLDhCQUE4QkwsVUFBVSxTQUFWLEdBQXNCLEVBQXBELENBQWhCLEVBQXlFLFNBQVNELFdBQVcsWUFBSSxDQUFFLENBQWpCLEdBQW9CRSxPQUF0RztBQUNLRCwrQkFBVyw4QkFBQyxnQkFBRCxJQUFNLGdCQUFOLEVBQWlCLFdBQVcsYUFBNUIsRUFBMkMsTUFBSyxRQUFoRCxHQURoQjtBQUVJLGtEQUFDLGdCQUFELElBQU0sZ0JBQU4sRUFBaUIsV0FBV0EsVUFBVSxhQUFWLEdBQTBCLGFBQXRELEVBQXFFLE1BQU1BLFVBQVUsT0FBVixHQUFvQixVQUEvRjtBQUZKLGlCQURHO0FBS0ZFLDZCQUFhQSxXQUFXRSxHQUFYLEVBQWdCSixPQUFoQixDQUFiLEdBQXdDLGdFQUFTSCxRQUFULElBQW1CLFNBQVNNLE9BQTVCLEVBQXFDLEtBQUtDLEdBQTFDO0FBTHRDLGFBQVA7QUFPSDs7O0VBaENlRSxnQyxHQVZwQjs7O0FBVU1YLEssQ0FDS1ksUyxHQUFZO0FBQ2ZILFNBQUtJLGdCQUFNRCxTQUFOLENBQWdCRSxNQUROO0FBRWZULGFBQVNRLGdCQUFNRCxTQUFOLENBQWdCRyxJQUZWO0FBR2ZULGFBQVNPLGdCQUFNRCxTQUFOLENBQWdCSSxJQUhWLEVBR2lCO0FBQ2hDUixhQUFTSyxnQkFBTUQsU0FBTixDQUFnQkksSUFKVixFQUlrQjtBQUNqQ1QsZ0JBQVlNLGdCQUFNRCxTQUFOLENBQWdCSSxJQUxiLEVBS3FCO0FBQ3BDWixjQUFVUyxnQkFBTUQsU0FBTixDQUFnQkcsSUFOWCxFQU1tQjtBQUNsQ2IsY0FBVVcsZ0JBQU1ELFNBQU4sQ0FBZ0JLLE1BUFgsQ0FPcUI7QUFQckIsQztBQURqQmpCLEssQ0FXS2tCLFksR0FBZSxFO2tCQXdCWGxCLEsiLCJmaWxlIjoiSW1hZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyAtLVxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBJY29uIGZyb20gXCIuLi9pY29uL0ZBSWNvblwiO1xuaW1wb3J0IFwiLi9JbWFnZS5zY3NzXCI7XG5pbXBvcnQgQWJzdHJhY3RSZWFjdENvbXBvbmVudCBmcm9tIFwiLi4vQWJzdHJhY3RSZWFjdENvbXBvbmVudFwiO1xuaW1wb3J0IGNsYXNzTmFtZXMgZnJvbSAnY2xhc3NuYW1lcyc7XG5cbi8qKlxuICogS29tcG9uZW50YSBvYnLDoXprdSBzIG1vxb5ub3N0w60gamVkbnUgdnlicmF0IGtsaWtudXTDrW0gbmEgY2hlY2tib3guXG4gKi9cbmNsYXNzIEltYWdlIGV4dGVuZHMgQWJzdHJhY3RSZWFjdENvbXBvbmVudCB7XG4gICAgc3RhdGljIFByb3BUeXBlcyA9IHtcbiAgICAgICAgc3JjOiBSZWFjdC5Qcm9wVHlwZXMuc3RyaW5nLFxuICAgICAgICBjaGVja2VkOiBSZWFjdC5Qcm9wVHlwZXMuYm9vbCxcbiAgICAgICAgb25DaGVjazogUmVhY3QuUHJvcFR5cGVzLmZ1bmMsICAvLyBrbGlrIG5hIGNoZWNrYm94XG4gICAgICAgIG9uQ2xpY2s6IFJlYWN0LlByb3BUeXBlcy5mdW5jLCAgIC8vIGtsaWsgbmEgb2Jyw6F6ZWsgLSBuYXDFmS4gcHJvIG1vxb5ub3N0IGFrY2Ugem9icmF6ZW7DrSBuw6FobGVkdSBhcG9kLlxuICAgICAgICByZW5kZXJJdGVtOiBSZWFjdC5Qcm9wVHlwZXMuZnVuYywgICAvLyByZW5kZXIgb2Jyw6F6a3UsIHBva3VkIGplIHBvdMWZZWJhIGppbsO9IG5lxb4gc3RhbmRhcmRuw61cbiAgICAgICAgZGlzYWJsZWQ6IFJlYWN0LlByb3BUeXBlcy5ib29sLCAgIC8vIGplIGRpc2FibGVkXG4gICAgICAgIGltZ1Byb3BzOiBSZWFjdC5Qcm9wVHlwZXMub2JqZWN0LCAgIC8vIHByb3BzIHBybyBpbWcgZWxlbWVudFxuICAgIH07XG5cbiAgICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIH07XG5cbiAgICByZW5kZXIoKSB7XG4gICAgICAgIGNvbnN0IHtpbWdQcm9wcywgY2xhc3NOYW1lLCBkaXNhYmxlZCwgY2hlY2tlZCwgb25DaGVjaywgcmVuZGVySXRlbSwgb25DbGljaywgc3JjfSA9IHRoaXMucHJvcHM7XG5cbiAgICAgICAgY29uc3QgY2xzQ29udCA9IGNsYXNzTmFtZXMoXG4gICAgICAgICAgICBcImltYWdlLWNvbnRhaW5lclwiLFxuICAgICAgICAgICAgY2xhc3NOYW1lLCB7XG4gICAgICAgICAgICAgICAgZGlzYWJsZWRcbiAgICAgICAgICAgIH1cbiAgICAgICAgKTtcblxuXG4gICAgICAgIHJldHVybiA8ZGl2IGNsYXNzTmFtZT17Y2xzQ29udH0+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT17XCJjaGVjayBwLTIgZmEtc3RhY2sgZmEtc21cIiArIChjaGVja2VkID8gXCIgYWN0aXZlXCIgOiBcIlwiKX0gb25DbGljaz17ZGlzYWJsZWQgPyAoKT0+e30gOiBvbkNoZWNrfT5cbiAgICAgICAgICAgICAgICB7Y2hlY2tlZCAmJiA8SWNvbiBmaXhlZFdpZHRoIGNsYXNzTmFtZT17XCJmYS1zdGFjay0yeFwifSBpY29uPVwiY2lyY2xlXCIgLz59XG4gICAgICAgICAgICAgICAgPEljb24gZml4ZWRXaWR0aCBjbGFzc05hbWU9e2NoZWNrZWQgPyBcImZhLXN0YWNrLTF4XCIgOiBcImZhLXN0YWNrLTJ4XCJ9IGljb249e2NoZWNrZWQgPyBcImNoZWNrXCIgOiBcImNpcmNsZS1vXCJ9IC8+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIHtyZW5kZXJJdGVtID8gcmVuZGVySXRlbShzcmMsIGNoZWNrZWQpIDogPGltZyB7Li4uaW1nUHJvcHN9IG9uQ2xpY2s9e29uQ2xpY2t9IHNyYz17c3JjfS8+fVxuICAgICAgICA8L2Rpdj47XG4gICAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBJbWFnZTtcbiJdfQ==